// ════════════════════════════════════════════════════════════════════════════
//  Udisys Gestor Web  —  src/features/customers/services/personService.ts
// ════════════════════════════════════════════════════════════════════════════

import { apiClient } from '@/lib/apiClient';
import type {
  Cliente,
  ClienteDetalheApi,
  CriarClienteRequest,
  AtualizarClienteRequest,
  PaginatedResult,
} from '../types';

const BASE = '/api/clientes';

export const personService = {
  async getAll(params?: {
    pagina?: number;
    tamanhoPagina?: number;
  }): Promise<PaginatedResult<Cliente>> {
    const { data } = await apiClient.get<PaginatedResult<Cliente>>(BASE, {
      params: {
        pagina:        params?.pagina        ?? 1,
        tamanhoPagina: params?.tamanhoPagina ?? 20,
      },
    });
    return data;
  },

  async getById(id: string | number): Promise<ClienteDetalheApi> {
    const { data } = await apiClient.get<ClienteDetalheApi>(`${BASE}/${id}`);
    return data;
  },

  async create(cliente: CriarClienteRequest): Promise<ClienteDetalheApi> {
    const { data } = await apiClient.post<ClienteDetalheApi>(BASE, cliente);
    return data;
  },

  async update(id: string | number, cliente: AtualizarClienteRequest): Promise<ClienteDetalheApi> {
    const { data } = await apiClient.put<ClienteDetalheApi>(`${BASE}/${id}`, cliente);
    return data;
  },

  async delete(id: string | number): Promise<void> {
    await apiClient.delete(`${BASE}/${id}`);
  },

  async search(query: string): Promise<Cliente[]> {
    const { data } = await apiClient.get<Cliente[]>(`${BASE}/buscar`, {
      params: { termo: query },
    });
    return data;
  },

  async getInadimplentes(): Promise<Cliente[]> {
    const { data } = await apiClient.get<Cliente[]>(`${BASE}/inadimplentes`);
    return data;
  },

  async getVendedores(): Promise<Cliente[]> {
    const { data } = await apiClient.get<Cliente[]>(`${BASE}/vendedores`);
    return data;
  },
};
